// Feature flag utility
const feature = (enabled = false, required = false) => ({ enabled, required });

const ENABLED = feature(true, false);
const DISABLED = feature(false, false);

// All contributor fields are enabled by default
const defaultContributorFeatures = {
  producer: ENABLED,
  anchor: ENABLED,
  script_writer: ENABLED,
  video_editor: ENABLED,
  cameraman: ENABLED,
  photographer: ENABLED,
  researcher: ENABLED,
  compiler: ENABLED,
  curator: ENABLED,
  reporter: ENABLED,
  author: ENABLED,
};

const withOverrides = (
  overrides: Partial<typeof defaultContributorFeatures>
): typeof defaultContributorFeatures => ({
  ...defaultContributorFeatures,
  ...overrides,
});

// Map based on denmark/no_denmark configuration
const contributorFeatureMap = {
  denmark: withOverrides({
    // All fields enabled by default for denmark
    // Override specific fields here if needed
  }),
  no_denmark: withOverrides({
    // All fields enabled by default for no_denmark
    // Override specific fields here if needed
    photographer: DISABLED,
    researcher: DISABLED,
    compiler: DISABLED,
    curator: DISABLED,
    reporter: DISABLED,
    author: DISABLED,
  }),
} as const;

export type ContributorFeatureMapKey = keyof typeof contributorFeatureMap;
export type ContributorFeatures = typeof defaultContributorFeatures;

export const getContributorFeatures = (
  type: ContributorFeatureMapKey
): ContributorFeatures => {
  return contributorFeatureMap[type] ?? defaultContributorFeatures;
};
